module.exports = __webpack_public_path__ + "img/mob_about_01.606ebe6b.png";